import axios from 'axios'
import EventEmit from '@/utils/EventEmit'

const baseURL = process.env.NODE_ENV === 'development'
  || process.env.STAGE === 'test' || window.location.href.indexOf('testcluster-k8s-01.iweikan.cn') > -1
  ? '//test-pcwallpaper.zhhainiao.com'
  : '//pcwallpaper.zhhainiao.com'

const instance = axios.create({
  baseURL,
  timeout: 60000 * 5,
  headers: {
    post: {
      'Content-Type': 'application/json',
      'X-Cf-Device-Id': 'xxxx-xxx-xxx',
      'X-Cf-Platform': 'webview',
    },
  },
})

instance.interceptors.request.use((config) => {
  return config
})

function handleErrorResponse(res) {
  switch (res.resp_common.ret) {
    case 4001004:
    case 4001002:
      // if (typeof window !== 'undefined') {
      //   window.app.$store.dispatch('user/showLoginModal')
      // }
      EventEmit.$emit('SHOW_LOGIN_DIALOG')
      break
    default:
    // if (retCodeMap[res.ret] || res.msg) {
    //   toast(retCodeMap[res.ret] || res.msg)
    // }
  }
}

let errorHandleTimer

function generateErrorResponse(res) {
  errorHandleTimer = setTimeout(() => {
    if (!res.handled) {
      handleErrorResponse(res)
    }
  }, 10)
  const ret = res.resp_common.ret
  Object.defineProperty(res, 'ret', {
    get() {
      clearTimeout(errorHandleTimer)
      return ret
    },
  })
  return res
}

instance.interceptors.response.use((res) => {
  const data = res.data
  if (data.resp_common.ret !== 0) {
    return Promise.reject(generateErrorResponse(data))
  }

  return data
}, (err) => {
  // if (process.env.VUE_ENV === 'server') {
  //   console.log('request error:', err)
  // }
  // sentryCaptureException(err)
  return Promise.reject(err)
})

export default instance
